import { Zappyrent } from '@zappyrent/hundop';

import { IUser } from '../../shared/ts/user';
import useStore from '../../store';
import { StyledLink, StyledWrapper } from './Logo.styles';

const Logo = ({
  defaultType,
}: {
  defaultType?: 'landlord' | 'tenant';
}): JSX.Element => {
  const user = useStore(state => state.user);
  let type = defaultType;

  if (user) {
    type = (user as IUser).type;
  }

  return (
    <StyledWrapper>
      <StyledLink href={process.env.REACT_APP_SITE_URL} title="Zappyrent">
        <Zappyrent user={type} />
      </StyledLink>
    </StyledWrapper>
  );
};

export default Logo;
